import { Skeleton } from "@/components/ui/skeleton";

export function DocumentSkeleton() {
	return (
		<div className="manual-doc">
			{[0, 1, 2].map((page) => (
				<div key={page} className="page">
					<Skeleton className="mb-4 h-7 w-1/2 bg-border/70" />

					{[0, 1, 2, 3].map((row) => (
						<Skeleton key={row} className="mb-2 h-4 w-full bg-border/70" />
					))}
				</div>
			))}
		</div>
	);
}
